export const STATIC_PRODUCTS = [
  {
    id: "notizbuch-1",
    name: "Aesthetic Notizbuch",
    category: "notizbuch",
    description: "Ein elegantes Notizbuch für Gedanken, Ziele, Duʿā und tägliche Erinnerungen.",
    price: 9.99,
    image_url: "https://images.unsplash.com/photo-1517842645767-c639042777db?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "stift-1",
    name: "Eleganter Stift",
    category: "stift",
    description: "Ein schöner Stift für Planung, Journaling und liebevolle Geschenksets.",
    price: 4.99,
    image_url: "https://images.unsplash.com/photo-1583485088034-697b5bc54ccd?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "geschenk-1",
    name: "Geschenkbox",
    category: "geschenk",
    description: "Eine kleine Geschenkbox mit liebevoll ausgewählten Schreibwaren und Details.",
    price: 14.99,
    image_url: "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "buch-1",
    name: "Inspirierendes Buch",
    category: "buch",
    description: "Eine sorgfältig ausgewählte Lektüre für ruhige Momente und bleibende Gedanken.",
    price: 12.99,
    image_url: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?q=80&w=1200&auto=format&fit=crop",
  },
];

export const WHATSAPP_NUMBER = "4915229516378"; // Replace with your WhatsApp number, for example 447123456789

export function createWhatsAppLink(product) {
  const message = product
    ? `Hallo, ich möchte ${product.name} bestellen. Ist es verfügbar?`
    : "Hallo, ich möchte bei Dar al Midad bestellen oder mehr Informationen erhalten.";
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
